import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { IconContext } from 'react-icons';
import { GiHamburgerMenu } from "react-icons/gi";
import { IoCloseSharp } from "react-icons/io5";

import { ContactUsButton } from "../screens/Home";
import EbookModal from "./EbookModal";
import ContactUsModal from "./ContactUsModal";
import SpLabsLogo from "../assets/SP-Labs-logo.png";

import "./Header.css";

const Header = () => {

    const [showContactUsModal, setShowContactUsModal] = useState(false);
    const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
    const [showEbookModal, setShowEbookModal] = useState(false);

    const navigate = useNavigate();

    return (
        <header className="header-section">

            {showContactUsModal && <ContactUsModal closeModal={() => setShowContactUsModal(false)} />}

            {showEbookModal &&
                <EbookModal closeModal={() => setShowEbookModal(false)} />
            }

            <div className="header-banner-row">
                <div>
                    <p className="header-banner-text">
                        Download our free eBook: <a className="header-banner-text-clickable" onClick={() => setShowEbookModal(true)}>The AI Manual</a>
                    </p>
                </div>
            </div>

            <div className="header-container">

                <img src={SpLabsLogo} id="sp-labs-logo" onClick={() => navigate("/")} />
                <div className="header-right-col">
                    <p id="blog-link-text" onClick={() => navigate("/ai-basics")}>Learn</p>
                    <ContactUsButton onClick={() => setShowContactUsModal(true)} />
                </div>

                <div className="hamburger-icon-container" onClick={() => setShowHamburgerMenu(true)}>
                    <IconContext.Provider
                        value={{ className: "hamburger-icon" }}>
                        <GiHamburgerMenu />
                    </IconContext.Provider>
                </div>

                {showHamburgerMenu &&
                    <div className="hamburger-menu-options-container">
                        <div className="hamburger-menu">
                            <div className="hamburger-close-icon-container" onClick={() => setShowHamburgerMenu(false)}>
                                <IconContext.Provider
                                    value={{ className: "hamburger-icon" }}>
                                    <IoCloseSharp />
                                </IconContext.Provider>
                            </div>
                            <p className="hamburger-menu-text" onClick={() => navigate("/ai-basics")}>
                                Learn
                            </p>
                            <p className="hamburger-menu-text" onClick={() => { setShowContactUsModal(true); setShowHamburgerMenu(false) }}>
                                Contact
                            </p>
                        </div>
                    </div>
                }

            </div>

        </header>
    )

}

export default Header;